/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_10_MonthlyInputs */

const en_landing_pricing_feature_10_monthly = /** @type {(inputs: Landing_Pricing_Feature_10_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 tool submissions / month`)
};

const zh_landing_pricing_feature_10_monthly = /** @type {(inputs: Landing_Pricing_Feature_10_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月 10 次工具提交`)
};

/**
* | output |
* | --- |
* | "10 tool submissions / month" |
*
* @param {Landing_Pricing_Feature_10_MonthlyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_10_monthly = /** @type {((inputs?: Landing_Pricing_Feature_10_MonthlyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_10_MonthlyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_10_monthly(inputs)
	return zh_landing_pricing_feature_10_monthly(inputs)
});
export { landing_pricing_feature_10_monthly as "landing.pricing.feature_10_monthly" }